module.exports = __webpack_public_path__ + "static/media/printing-services-img15.90c393b7.jpg";